import { ACTION_TYPE } from '../core/redux/actionType';
import { IAppState } from '../core/redux/IAppState';
import { Action } from 'redux';
import * as R from 'ramda';


type clipboardAction = {
  type: ACTION_TYPE.SET_COPY_TO_CLIPBOARD;
  textToCopy: string;
  successMsg: string;
};


/**
 * Creates an action you can dispatch to change the app state to copy the provided text to clipboard and show a Snackbar
 * to reflect that the copy action occurred.
 * @param textToCopy - The text to copy to the clipboard
 * @param successMsg - The message to show on successful copying to clipboard
 */
export const copyToClipboardAction = (
  textToCopy: string,
  successMsg: string,
): clipboardAction => ({
  type:       ACTION_TYPE.SET_COPY_TO_CLIPBOARD,
  textToCopy: textToCopy,
  successMsg: successMsg,
});


/**
 * Creates an action you can dispatch to clear copyToClipboard from the app state
 */
export const clearCopyToClipboardAction = {
  type: ACTION_TYPE.CLEAR_COPY_TO_CLIPBOARD,
};


export const copyToClipboardReducer = (state: IAppState, action: Action): IAppState => {
  if (action.type === ACTION_TYPE.CLEAR_COPY_TO_CLIPBOARD) {
    return R.mergeDeepRight(
      state,
      {
        textToClipboard: undefined,
        clipboardMsg:    undefined,
      },
    );
  }

  if (action.type === ACTION_TYPE.SET_COPY_TO_CLIPBOARD) {
    const cpAction = action as clipboardAction;

    return R.mergeDeepRight(
      state,
      {
        textToClipboard: cpAction.textToCopy,
        clipboardMsg:    cpAction.successMsg,
      },
    );
  }

  return state;
};
